/**
 * Translations for standalone modal components (RsModal*).
 *
 * Each namespace here is consumed by a single modal (RsModalAdUrls,
 * RsModalChangesSummary, RsModalRentalsAdUrls, RsModalUnitSummary). They were
 * previously housed in globals.ts; they live here to keep globals.ts scoped to
 * genuinely cross-cutting strings. Keys stay spread at the tree root (see
 * index.ts), so call sites are unchanged (e.g. $ts('adUrls.title')).
 */

export const modalsEn = {
  adUrls: {
    baths: 'Baths',
    beds: 'Beds',
    listingUrl: 'Listing URL',
    listingUrls: 'Listing URLs',
    notEligible: 'This property is not eligible to be listed on {site} since it\'s location is not based in {province}.',
    rentalListingSite: 'Rental Listing Site',
    title: 'View Rental Listings',
  },
  changesSummaryModal: {
    changeCount: '{count} change | {count} changes',
    changeFrom: 'From',
    changeTo: 'To',
    defaultTitle: 'Changes Summary',
    off: 'OFF',
    on: 'ON',
    title: '{subject}(s) Affected ({count})',
    toLabel: 'To:',
    undoTooltip: 'This value will not change. Click to undo.',
  },
  rentalsAdUrls: {
    listingUrl: 'Listing URL',
    notEligibleProvince: 'This property is not eligible to be listed on {site} since it\'s location is not based in {province}.',
    quebec: 'Quebec',
    rentalListingSite: 'Rental Listing Site',
    suiteName: 'Suite Name',
    title: 'View Rental Listings',
  },
  unitSummary: {
    availability: 'Availability',
    available: 'Available',
    baths: 'Baths',
    beds: 'Beds',
    deposit: 'Deposit',
    manageUnits: 'Manage Units',
    name: 'Name',
    photos: 'Photos',
    rent: 'Rent',
    status: 'Status',
    title: 'Unit Summary - {name}',
    unavailable: 'Unavailable',
    depositTypes: {
      none: 'None',
      'half-month': 'Half Month Rent',
      'one-month': 'One Month Rent',
      'two-months': 'Two Months Rent',
      'last-month': 'Last Month Rent',
    },
  },
};

export const modalsFr = {
  adUrls: {
    baths: 'Salles de bain',
    beds: 'Chambres',
    listingUrl: 'URL de l\'annonce',
    listingUrls: 'URL des annonces',
    notEligible: 'Cette propriété n\'est pas admissible à une inscription sur {site}, car son emplacement n\'est pas situé au {province}.',
    rentalListingSite: 'Site d\'annonces locatives',
    title: 'Voir les annonces locatives',
  },
  changesSummaryModal: {
    changeCount: '{count} modification | {count} modifications',
    changeFrom: 'De',
    changeTo: 'À',
    defaultTitle: 'Résumé des modifications',
    off: 'Désactivé',
    on: 'Activé',
    title: '{subject}(s) affecté(s) ({count})',
    toLabel: 'Vers :',
    undoTooltip: 'Cette valeur ne changera pas. Cliquez pour annuler.',
  },
  rentalsAdUrls: {
    listingUrl: 'URL de l\'annonce',
    notEligibleProvince: 'Cette propriété n\'est pas admissible à une inscription sur {site}, car son emplacement n\'est pas situé au {province}.',
    quebec: 'Québec',
    rentalListingSite: 'Site d\'annonces locatives',
    suiteName: 'Nom de la suite',
    title: 'Voir les annonces locatives',
  },
  unitSummary: {
    availability: 'Disponibilité',
    available: 'Disponible',
    baths: 'Salles de bain',
    beds: 'Chambres',
    deposit: 'Dépôt',
    manageUnits: 'Gérer les logements',
    name: 'Nom',
    photos: 'Photos',
    rent: 'Loyer',
    status: 'Statut',
    title: 'Résumé des logements - {name}',
    unavailable: 'Non disponible',
    depositTypes: {
      none: 'Aucun',
      'half-month': 'Un demi-mois de loyer',
      'one-month': 'Un mois de loyer',
      'two-months': 'Deux mois de loyer',
      'last-month': 'Dernier mois de loyer',
    },
  },
};
